import { render } from "./collection-product-swatch.vue?vue&type=template&id=602642c8&scoped=true"
import script from "./collection-product-swatch.vue?vue&type=script&lang=js"
export * from "./collection-product-swatch.vue?vue&type=script&lang=js"

import "./collection-product-swatch.vue?vue&type=style&index=0&id=602642c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602642c8"]])

export default __exports__